(ns frontend.ux-overhaul.listing.company.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.company.event :as company-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "company-listing")

(defn- open-company!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/company})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/company
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :company
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-company
                                 :label    (loc/tr :company-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-event/create-company]}
                                {:id                  :bulk-edit-companies
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::company-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-companies
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::company-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-companies
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-companies-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::company-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/company})
                                (menu-actions/landing-page-action {:view-id :companies-grid})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :companies)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.company/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::company-event/create-company])
         :on-row-clicked           open-company!
         :on-card-clicked          open-company!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/company}]
       [menu-actions/field-requirements-modal]])}))
